module.exports = __webpack_public_path__ + "static/media/Vauxhall-Motors-logo.00a35fd1.png";